<template>
  <v-layout class="grey lighten-4 pa-3" column>
    <v-alert dense prominent text type="info">
      <span>Estimado restaurante: Ya se encuentra disponible la nueva versión de EATO, te invitamos a registrate. <a href="https://auth.eato.mx/" target="_blank">haz click aquí</a></span>
    </v-alert>
    <div v-if="tabs.length > 1">
      <v-tabs
        v-model="activeTab"
        grow>

        <v-tab v-for="(tab, index) in tabs" :key="`tab-${index}`" :to="{ name: tab.name }">
          {{ $t(tab.tabMenu) }}
        </v-tab>

      </v-tabs>

      <v-tabs-items
        v-model="activeTab"
        touchless>
        <v-tab-item
          :transition="false"
          :reverse-transition="false"
          class="grey lighten-4"
          v-for="(tab, index) in tabs"
          :key="`item-${index}`"
          :value="tab.route">
          <div v-if="activeTab && activeTab === $route.path && activeTab === tab.route" >
            <router-view />
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>

    <div v-else>
      <router-view />
    </div>
  </v-layout>
</template>

<script>
export default {
  name: 'Purchase',
  data () {
    return {
      activeTab: null
    }
  },
  async mounted () {
    if (['manager', 'read-only', 'buyer'].includes(this.$is())) {
      await this.getRestaurantsettings()
    }
  },
  computed: {
    permissions () {
      return this.$store.state.login.permissions
    },
    tabs () {
      const tabs = [
        { tabMenu: 'menu.purchase.manualPurchase', name: 'PurchaseOrdersCreate', route: `/purchase/purchase-orders-create`, roles: ['manager', 'buyer'], permission: 'manual-purchase-orders-form' },
        { tabMenu: 'menu.purchase.intelligentPurchase', name: 'IntelligentPurchase', route: `/purchase/intelligent-purchase`, roles: ['manager', 'buyer'], permission: 'smart-purchase-orders-form' },
        { tabMenu: 'menu.purchase.list', name: 'PurchaseOrders', route: `/purchase/purchase-orders`, roles: ['manager', 'provider', 'provider-buyer', 'stockmanager', 'buyer'], permission: 'purchase-orders-list' },
        { tabMenu: 'menu.purchase.invoices', name: 'Invoices', route: `/purchase/invoices`, roles: ['manager', 'buyer'] }
      ]
      return tabs.filter(tab => {
        if (tab.permission) {
          return this.permissions['purchase-orders'].components[tab.permission].visible
        }
        return tab.roles.includes(this.$is())
      })
    }
  },
  methods: {
    async getRestaurantsettings () {
      const response = await this.$api.get(`/v1/restaurants/${this.$store.state.currentRestaurant.data._id}/settings`)
      const restaurant = this.$store.state.currentRestaurant.data
      restaurant.taxInformation = response
      this.$store.commit('setRestaurant', restaurant)
    }
  }
}
</script>
